import type { IconSvgObject } from './types';

const FocusIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 7.73735C20.9133 5.98847 20.654 4.89808 19.8783 4.12242C19.1026 3.34675 18.0121 3.08746 16.2632 3.00079M3 7.73656C3.08668 5.98769 3.34598 4.8973 4.1217 4.12163C4.89741 3.34596 5.98786 3.08667 7.73684 3M21 16.2627C20.9133 18.0115 20.654 19.1019 19.8783 19.8776C19.1026 20.6533 18.0121 20.9125 16.2632 20.9992M3 16.2634C3.08668 18.0123 3.34598 19.1027 4.1217 19.8784C4.89741 20.654 5.98786 20.9133 7.73684 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FocusIcon;
